/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const PurposeType = {
    Appointment: 'Appointment',
    Attendance: 'Attendance'
} as const;
export type PurposeType = typeof PurposeType[keyof typeof PurposeType];


export function instanceOfPurposeType(value: any): boolean {
    for (const key in PurposeType) {
        if (Object.prototype.hasOwnProperty.call(PurposeType, key)) {
            if (PurposeType[key as keyof typeof PurposeType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PurposeTypeFromJSON(json: any): PurposeType {
    return PurposeTypeFromJSONTyped(json, false);
}

export function PurposeTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): PurposeType {
    return json as PurposeType;
}

export function PurposeTypeToJSON(value?: PurposeType | null): any {
    return value as any;
}

export function PurposeTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): PurposeType {
    return value as PurposeType;
}

